import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import { getPrintedDate, getPrintedDateLocal } from 'utils/date'
import { NOTIFICATION_NAMES } from './constants'
import * as styles from './Notifications.scss'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { SUBSCRIPTION_PLAN_TYPE } from 'constants/subscription'

const cx = classNames.bind(styles)

interface IProps {
  items: NOTIFICATION_NAMES[],
  t: Text,
  isResendingEmail: boolean,
  onResend: () => void,
  onGoToPaymentHistory: () => void,
  onGoToRenewalProcess: () => void,
  onGoToEnrollPlanProcess: () => void,
  contacts: any,
  futureSubscription: any,
}

const Notifications: React.FC<IProps> = ({ items, t, isResendingEmail, onResend, onGoToPaymentHistory,
  onGoToRenewalProcess, onGoToEnrollPlanProcess, contacts, futureSubscription }) => (
  <React.Fragment>
    {items.map(name => {
      if (name === NOTIFICATION_NAMES.notConfirmedEmail) {
        return (
          <div key={name} className={styles.root}>
            {t('notConfirmedEmail')}
            &nbsp;
            <a
              href='#'
              onClick={onResend}
              className={cx({ disabledLink: isResendingEmail })}
            >
              {t('resendEmailLink')}
            </a>
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.printWillBeDelivered) {
        return (
          <div key={name} className={cx('root', 'success')}>
            {t('printerWillBeDelivered')}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.cardExpired) {
        return (
          <div key={name} className={styles.root}>
            {t('cardExpired')}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.askingReturnPrinter) {
        return (
          <div key={name} className={styles.root}>
            {t('askingReturnPrinter')}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.subscriptionCanceled) {
        return (
          <div key={name} className={styles.root}>
            {t('subscriptionCanceled')}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.subscriptionRenewed) {
        return (
          <div key={name}>
            <div className={cx('root', 'success')}>
              {t('subscriptionRenewed')}
            </div>
            {(futureSubscription !== EMPTY_OBJECT && futureSubscription.subscriptionContractType === SUBSCRIPTION_PLAN_TYPE.contract) &&
              <div className={cx('root', 'success')}>
                {t('futureContract', { termsStartDate: getPrintedDateLocal(futureSubscription.termsStartDate) })}
              </div>
            }
            {(futureSubscription !== EMPTY_OBJECT && futureSubscription.subscriptionContractType === SUBSCRIPTION_PLAN_TYPE.monthToMonth) &&
              <div className={cx('root', 'success')}>
                {t('futureM2M', { termsEndDate: getPrintedDateLocal(futureSubscription.termsEndDate) })}
              </div>
            }
          </div>
        )
      }

      if (name === NOTIFICATION_NAMES.subscriptionWillExpireSoon) {
        return (
          <div key={name} className={cx('root', 'warning', 'contractExpire')}>
            <div>{t('subscriptionEndSoon')}</div>
            &nbsp;
            <div className={styles.linkAlignRight}>
              <a href='#' onClick={onGoToRenewalProcess}>
                {t('renewalOptions')}
              </a>
            </div>
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.subscriptionExpired) {
        return (
          <div key={name} className={cx('root', 'error', 'contractExpire')}>
            <div>{t('subscriptionExpired')}</div>
            &nbsp;
            <div className={styles.linkAlignRight}>
              <a href='#' onClick={onGoToEnrollPlanProcess}>
                {t('enrollAgain')}
              </a>
            </div>
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.checkCreditCard) {
        return (
          <div key={name} className={cx('root', 'warning')}>
            {t('checkCreditCard')}
            &nbsp;
            <a href='#' onClick={onGoToPaymentHistory}>
              {t('viewMoreLink')}
            </a>
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.printerWillBeLocked) {
        return (
          <div key={name} className={styles.root}>
            {t('printerWillBeLocked')}
            &nbsp;
            <a href='#' onClick={onGoToPaymentHistory}>
              {t('viewMoreLink')}
            </a>
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.printerLocking) {
        return (
          <div key={name} className={styles.root}>
            {t('printerLocking1')}
            &nbsp;
            <a href='#' onClick={onGoToPaymentHistory}>
              {t('viewMoreLink')}
            </a>
            &nbsp;
            {t('printerLocking2')}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.printerLocked) {
        return (
          <div key={name} className={styles.root}>
            {t('printerLocked', { phoneNumber: contacts.general.phoneNumber })}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.printerWillBeUnlocked) {
        return (
          <div key={name} className={cx('root', 'warning')}>
            {t('printerWillBeUnlocked')}
          </div>
        )
      }
      if (name === NOTIFICATION_NAMES.printerWillBeSoon) {
        return (
          <div key={name} className={cx('root', 'success')}>
            {t('printerWillBeSoon')}
          </div>
        )
      }
      return null
    })}
  </React.Fragment>
)

export default Notifications
